import { datadogLogs } from '@datadog/browser-logs';
import { type datadogRum } from '@datadog/browser-rum';
import { string as zString } from 'zod';

export type DataDogRum = typeof datadogRum;

const PUBLIC_DATADOG_KEY = zString({
  required_error: 'Missing PUBLIC_DATADOG_KEY from process.env',
}).parse(process.env.PUBLIC_DATADOG_KEY);

const DD_ENV = process.env.PUBLIC_DD_ENV;

let datadogRumInitialized: DataDogRum | null = null;

export function reset() {
  datadogRumInitialized = null;
}

export function setInstance(dd: DataDogRum) {
  datadogRumInitialized = dd;
}

export function instance(): DataDogRum | null {
  if (process.env.NODE_ENV !== 'production') {
    if (datadogRumInitialized === null) {
      throw new Error('Datadog RUM not initialized');
    }
  }
  return datadogRumInitialized;
}

export function initialize() {
  datadogLogs.init({
    env: DD_ENV,
    service: 'web',
    clientToken: PUBLIC_DATADOG_KEY,
    forwardErrorsToLogs: true,
  });
}

export function getLogger() {
  if (datadogLogs.getInitConfiguration() === undefined) {
    initialize();
  }

  return datadogLogs.logger;
}
